export const ru = {
    isNotSet: 'не задан',
    perDay: 'в день',
    walletDayBudgetIsSet:
        'Ограничение среднего дневного бюджета работает на двух уровнях — на кампанию и на общий счет. На кампанию в среднем будет потрачена сумма, не превышающая самое строгое из ограничений. На общий счет установлено ограничение среднего дневного бюджета {sum} {currency} и режим показа «{mode}».'
};
